export const cellStyles = {
    whiteSpace: 'nowrap',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    alignItems:'center',
    padding:'4px 6px 4px 6px',
    height:'40px',
    color: '#444',
}
export const statusList = [{ id: 0, name: 'Inactive' }, { id: 1, name: 'Active' }]
export const ctreditLimitList = [{ id: 0, name: 'Limited' }, { id: 1, name: 'No Limit' }]
export const commissionList = [{ id: 0, name: 'Percentage' }, { id: 1, name: 'Amount' }]
export const billingUnitList =[{id: -1, name: 'All'},{ id: 1, name: 'Per KG' },{ id: 2, name: 'Per Quantity' },
    // { id: 3, name: 'Per LR' },
    { id: 4, name: 'Per Kg-Km' },]
export const serviceTypeList = [{id: -1, name: 'All'},{ id: 1, name: 'By Bus' },{ id: 2, name: 'By Cargo' },{ id: 3, name: 'By Express Cargo' },{ id: 4, name: 'By Partner Cargo' },]
export const statusListWithAll = [{id: -1, name: 'All'},{ id: 0, name: 'Inactive' }, { id: 1, name: 'Active' }]
